import {
  GroupScoreDto,
  GroupScoreModel,
} from 'api/dto/new/SummaryCompared/Categories/GroupScore.dto';
import {
  mapQuestionItemDtoToModel,
  QuestionItemDto,
  QuestionItemModel,
} from 'api/dto/new/SummaryCompared/Questions/QuestionItem.dto';
import { CategoryDto, CategoryModel, mapCategoryDtoToModel } from 'api/dto/new/Common/Category.dto';

export type CategoryItemDto = {
  byGroup: Record<string, GroupScoreDto>;
  category: CategoryDto;
  questions: QuestionItemDto[];
};

export type CategoryItemModel = {
  byGroup: Record<string, GroupScoreModel>;
  category: CategoryModel;
  questions: QuestionItemModel[];
};

export const mapCategoryItemDtoToModel = (dto: CategoryItemDto): CategoryItemModel => ({
  byGroup: dto.byGroup,
  category: mapCategoryDtoToModel(dto.category),
  questions: dto.questions.map(mapQuestionItemDtoToModel),
});
